import React from "react"
import logoName from "images/logo_name.svg"

interface PageHeaderProps {
  className?: string
}

const PageHeader: React.FC<PageHeaderProps> = ({ className = "" }) => {
  return (
    <div className={`page-header ${className}`}>
      <div className="page-header-logo">
        <img src={logoName} alt="Quadrant" className="page-header-logo-img" />
      </div>
      <div className="page-header-address">
        <div className="address-line">255 East 5th Street, Suite 3000</div>
        <div className="address-line">Cincinnati, OH, 45202</div>
      </div>
      <div className="page-header-divider"></div>
    </div>
  )
}

export default PageHeader
